"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHide = exports.useOpen = exports.DatePickerStore = exports.DatePickerContext = void 0;
var react_1 = require("react");
var store_utils_1 = require("./store-utils");
var utils_1 = require("./utils");
function reducer(state, action) {
    switch (action.type) {
        case "onChange": return __assign(__assign({}, state), { onChange: action.payload });
        case "setTimePicker": return __assign(__assign({}, state), { isTimePicker: action.payload });
        case "setDateString": return __assign(__assign({}, state), { dateStr: action.payload, time: (0, utils_1.parseTime)(action.payload) });
        case "setDate": return __assign(__assign({}, state), { date: action.payload });
        case "setSelected": return __assign(__assign({}, state), { selected: action.payload });
        case "setMode": return __assign(__assign({}, state), { timeMode: action.payload });
        case "setOpen": return __assign(__assign({}, state), { open: action.payload });
        default: return state;
    }
}
exports.DatePickerContext = (_a = (0, store_utils_1.createContextProvider)(reducer, {}), _a[0]), exports.DatePickerStore = _a[1];
function useOpen() {
    var dispatch = (0, react_1.useContext)(exports.DatePickerContext).dispatch;
    return function () { return dispatch({ type: "setOpen", payload: true }); };
}
exports.useOpen = useOpen;
function useHide() {
    var dispatch = (0, react_1.useContext)(exports.DatePickerContext).dispatch;
    return function () { return dispatch({ type: "setOpen", payload: false }); };
}
exports.useHide = useHide;
//# sourceMappingURL=calendar-store.js.map